import { makeOptionallyAuthenticatedQuery } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type {
  ManifestSummary as ManifestSummaryBase,
  ManifestSummaryBulkBrandsInner,
  ManifestSummaryTopResalePicksInner as ManifestSummaryTopResalePicksInnerBase,
} from '@b-stock/search-api-client'

import getManifestSummaryClient from './getManifestSummaryClient'

export type ManifestSummaryTopResalePick =
  ManifestSummaryTopResalePicksInnerBase & {
    reason?: string
  }

export type ManifestSummaryData = Omit<
  ManifestSummaryBase,
  'bulkBrands' | 'topResalePicks' | 'buyersPremium'
> & {
  buyersPremium: number | null
  bulkBrands?: Array<ManifestSummaryBulkBrandsInner>
  topResalePicks?: Array<ManifestSummaryTopResalePick>
}

const getManifestSummary = async (
  accessToken: string | null,
  listingId: string
): Promise<ManifestSummaryData> => {
  const client = getManifestSummaryClient()
  const axiosParams = buildAxiosRequestConfig({ accessToken })
  const { data } = await client.getManifestSummary(
    { listingId: [listingId] },
    axiosParams
  )
  const result = data[0]
  if (!result)
    throw new Error(`No manifest summary found for listing ${listingId}`)
  return result
}

const manifestSummaryQuery = makeOptionallyAuthenticatedQuery<
  [string],
  ManifestSummaryData
>('manifestSummary', getManifestSummary, {
  staleTime: 10 * 60 * 1000, // 10 minutes
  retry: false,
})

export default manifestSummaryQuery
